import { render, staticRenderFns } from "./VideosPainelView.vue?vue&type=template&id=62658a3e&scoped=true&"
import script from "./VideosPainelView.vue?vue&type=script&lang=js&"
export * from "./VideosPainelView.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=62658a3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62658a3e",
  null
  
)

export default component.exports